
import React, { Component } from 'react';
import { connect } from 'react-redux'
import { actions as kandyActions } from 'kandy-redux'
import { bindActionCreators } from 'redux'
import axios from 'axios'
import './style.scss'
import UploadList from '../../../components/UploadList/index.jsx'
import {
    Modal,
    message,
    Button,
    Popconfirm,
    Popover,
    Spin,
    Radio,
    Upload,
    Space,
    notification
} from 'antd';
import CarAndCardPicsTab from './CarAndCardPicsTab/index'
import { screenShotActions, reportPreviewActions, report } from '../../../lossAss/actions'
import moment from 'moment'
import RemarkBtn from '../../containers/ReportDetail/remarkBtn';

import {
    hasClaimPermission,
    hasCollectorPermission,
    hasDefLossPermission,
    isShowLocalUploadButton,
} from '../../../utils/agent'
import { shotPicsCheck } from '@service/report'
import RequestQueue from '@utils/RequestQueue'
import { Queue } from '../../../utils/queue';
import { checkImagePixelLimit } from './imageUploadCheck';
import { startUploadStatusReconcile, stopUploadStatusReconcile } from './uploadStatusReconciler';

const { newMedicalcheckDomain, server } = process.env || {};

/**
     * 医疗理算员
     */
function isAdjustAgentRole(agent) {
    const { agentRole = {} } = agent;
    return !!agentRole.isAdjust
}
/**
 * 查勘理算员
 */
function isSurveyAgentRole(agent) {
    const { agentRole = {} } = agent;
    return !!agentRole.isSurvey
}

const statusMap = {
    "claiming": "审核中",
    "claimed": "审核完成",
}
// 我的任务，照片取证
class FastForensics extends Component {
    constructor(props) {
        super(props)
        this.state = {
            date: new Date(),
            adjustStatus: 'create',//create 未创建 finish创建完成
            adjust: {},
            loadingModalContent: false,
            loadingModalContentTable: false,
            leaveMsg: '', //备注弹窗的备注内容
            visible: false,//截图弹出框显示控制
            visibleLoss: false,
            value: [],
            index: 0,
            loading: false,
            flowId: '',
            currentPreviewReport: '',
            currentCar: props.reportPreview.currentPreviewReport.ownCarLoss && props.reportPreview.currentPreviewReport.ownCarLoss._id ?
                props.reportPreview.currentPreviewReport.ownCarLoss._id : undefined,
            subState: 'reject',
            isShowSubStateConfirm: false,
            // 已上传的图片列表
            picsUploaded: [],
            //
            visibleClaimAdjuster: false,
            list: [],
            selectedRowKeys: [],

            cooperate: [],
            searchCooperate: undefined,
            keyWord: undefined,
            claimAdjusterId: undefined,
            sourceList: [],
        };
        this.localUploadHandledFiles = new WeakSet();
        this.CarAndCardPicsTab = React.createRef();
    }


    UNSAFE_componentWillReceiveProps(prevProps) {

        const { reportPreview, } = this.props
        if (prevProps.reportPreview.currentPreviewReport._id != reportPreview.currentPreviewReport._id) {
            this.setState({
                currentCar: prevProps.reportPreview.currentPreviewReport.ownCarLoss && prevProps.reportPreview.currentPreviewReport.ownCarLoss._id ?
                    prevProps.reportPreview.currentPreviewReport.ownCarLoss._id : undefined,
            })
            this.getAdjustReportInfo()
        }

    }

    componentDidMount() {
        this.getAdjustReportInfo()
        window.addEventListener("message", this.receiveMessage, false);
    }

    componentWillUnmount() {
        stopUploadStatusReconcile();
        window.removeEventListener("message", this.receiveMessage, false);
    }

    receiveMessage = (event) => {
        const data = event.data

        if (data.eventName === 'onChangeCheckbox') {
            this.setState({
                value: data.value,

            })
        }
        if (data.eventName === 'setSelectedRowKeys') {
            this.setState({
                selectedRowKeys: data.selectedRowKeys,
            })
        }
        if (data.eventName === 'skipAdjustment') {
            this.skip(data.loss)
        }
    }


    // 已结案
    onFinishClick = () => {
        const { actions, currentAgent, flowId } = this.props;
        const { subState } = this.state;
        this.setState({ isShowSubStateConfirm: false })
        actions.resetReportStateByAgent({ flowId, state: 'finished', subState, agentId: currentAgent._id });
    }

    showReturnedMsg = ({ returnType = '' }) => {
        const { actions } = this.props;
        actions.setReturnedModal({ returnType })
        this.getNextTime(returnType)

    }
    getNextTime = (returnType) => {

        const { actions, currentAgent, flowId } = this.props;

        if (!flowId) {
            return
        }
        axios({
            method: 'get',
            url: '/api/lossAss/report/follow',
            params: {
                flowId,
                agentId: currentAgent._id

            }
        }).then(res => {
            if (res.data.errCode == 0) {


                this.setState({
                    followDetails: res.data.result,
                    isShowNextTime: false,
                    nextTime: res.data.result.nextTime ? moment(res.data.result.nextTime) : undefined
                })

                actions.setReturnedModal({ isShow: true, returnType, nextTime: res.data.result.nextTime ? moment(res.data.result.nextTime) : undefined, followDetails: res.data.result, })

            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error(err.message || '请求/api/lossAss/report/follow失败')
        })
    }

    getImageBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    beforeLocalUpload = (file, fileList) => {
        if (this.localUploadHandledFiles.has(file)) return false;
        fileList.forEach(item => this.localUploadHandledFiles.add(item));
        this.validateAndUploadLocalPics(fileList).catch(error => {
            console.error('本地图片上传前校验失败', error);
            message.error('图片上传前校验失败，请重新选择图片');
        });
        return false;
    };

    validateAndUploadLocalPics = async (fileList) => {
        const validFiles = [];
        let failedCount = 0;

        for (const file of fileList) {
            let failureReason = '';
            if (!['image/jpeg', 'image/png'].includes(file.type)) {
                failureReason = `不支持的图片格式：${file.type || '未知格式'}，仅支持 JPEG、PNG`;
            } else if (file.size > 1024 * 1024 * 12) {
                failureReason = `图片大小为${(file.size / 1024 / 1024).toFixed(2)}MB，超过12MB限制`;
            } else {
                const pixelCheck = await checkImagePixelLimit(file);
                if (!pixelCheck.ok) failureReason = pixelCheck.reason;
            }

            if (failureReason) {
                file.status = 'error';
                file.failureReason = failureReason;
                failedCount += 1;
                message.error(`${file.name}：${failureReason}`);
            } else {
                validFiles.push(file);
            }
        }

        if (failedCount) message.error(`有${failedCount}张图片上传失败，请重新上传！`);
        if (!validFiles.length) return;

        message.success('图片正在上传！');
        return this.picsUpload(validFiles);
    };

    picsUpload = async (fileList) => {
        const { reportPreview = {}, actions, currentAgent, flowId } = this.props;
        const { currentCar } = this.state

        const label = 'Local'
        const subLabel = 'localEtc'
            const queue = new Queue();
            window.fileListQueue = queue;
            queue.enqueue(fileList.map(item => ({ file: item, asyncStatus: '' })))
            const list = queue.getList();
            const request = async (i) => {
                let image;
                try {
                    image = await this.getImageBase64(list[i].file)
                } catch (error) {
                    return {
                        error: true,
                        payload: {
                            result: {
                                uid: list[i].file.uid,
                                failureReason: `图片上传前处理失败${error && error.message ? `：${error.message}` : ''}`,
                            },
                        },
                    };
                }
                return actions.uploadPic({
                    image,
                    flowId,
                    lossId: currentCar,
                    label,
                    subLabel,
                    agentId: currentAgent._id,
                    isDone: i < 10 ? i === list.length - 1 : i % 10 === 0,
                    uid: list[i].file.uid
                })
            };

            let requestList = [];

            const instance = new RequestQueue();
            const callBack = (doneCount, result) => {
                const uploadResult = result && result.payload && result.payload.result || {};
                const uid = uploadResult.uid;
                // console.log(newFileList)
                // console.log(uid)
                const curIndex = list.findIndex(item => item.file.uid == uid);
                if (curIndex < 0) {
                    return;
                }
                const currentItem = queue.getList()[curIndex];
                const isTerminalStatus = ['success', 'fail', 'error'].includes(currentItem.asyncStatus);
                // const curData = list[curIndex]
                // curData.asyncStatus = result.error ? 'error' : 'uploading';
                console.log('上传开始', list)
                queue.update(curIndex, {
                    ...currentItem,
                    asyncStatus: isTerminalStatus ? currentItem.asyncStatus : result.error ? 'error' : 'uploading',
                    picId: isTerminalStatus ? currentItem.picId : uploadResult.picId || currentItem.picId,
                    failureReason: isTerminalStatus
                        ? currentItem.failureReason
                        : result.error ? uploadResult.failureReason || '图片上传失败，服务端未返回具体原因' : '',
                    httpStatus: isTerminalStatus ? currentItem.httpStatus : uploadResult.httpStatus,
                });
                let newList = queue.getList();
                console.log('上传完成', newList)
                // window.fileListQueue = queue
                console.log(newList.filter(file => (file.asyncStatus !== 'uploading' || file.asyncStatus !== '')))


                notification.open({
                    top: 100,
                    key: 'upload-list',
                    message: <>
                        <span style={{ fontWeight: 'blod' }}> 任务上传中</span>
                        <Spin wrapperClassName='black-spin' size='small' style={{ marginLeft: 10 }} />
                        <span style={{ color: '#ccc', marginLeft: 10 }}>成功{newList.filter((file) => file.asyncStatus === 'success').length}</span>
                        <span style={{ color: '#ccc', marginLeft: 10 }}>失败{newList.filter((file) => file.asyncStatus === 'error' || file.asyncStatus === 'fail').length}</span>
                        <span style={{ color: '#ccc', marginLeft: 10 }}>上传中{newList.filter((file) => file.asyncStatus === 'uploading' || file.asyncStatus === '').length}</span>
                    </>,
                    duration: 0,
                    description:
                        <UploadList data={newList} />,
                    onClick: () => {
                        console.log('Notification Clicked!');
                    },
                });
                // 如果全部上传失败
                if (newList.filter((item) => item.asyncStatus === 'uploading').length === 0) {
                    const failList = newList.filter((item) => item.asyncStatus === 'error' || item.asyncStatus === 'fail')
                    const successCount = newList.filter((item) => item.asyncStatus === 'success').length
                    notification.open({
                        top: 100,
                        key: 'upload-list',
                        message: <>
                        </>,
                        duration: failList.length === 0 ? 3 : 0,
                        description:
                            <UploadList successCount={successCount} status='finish' data={failList} />,
                        onClick: () => {
                            console.log('Notification Clicked!');
                        },
                    });
                }

                // 上传完成不用更新列表，等待 socket 推送更新通知
                // this.CarAndCardPicsTab._getPicsClassify();

            }
            for (let i = 0; i < fileList.length; i++) {
                requestList.push(instance.exec(() => request(i), callBack)
                    .catch(err => {
                        // 这里是否catch(err)取决于是否允许某个任务失败时，其他任务继续执行
                        console.log(err)
                    })
                )
            }
            return Promise.all(requestList).then((res) => {
                startUploadStatusReconcile({
                    flowId,
                    onChange: (newList) => {
                        notification.open({
                            top: 100,
                            key: 'upload-list',
                            message: <>任务上传中 <Spin wrapperClassName='black-spin' size='small' style={{ marginLeft: 10 }} />
                                <span style={{ color: '#ccc', marginLeft: 10 }}>成功{newList.filter(item => item.asyncStatus === 'success').length}</span>
                                <span style={{ color: '#ccc', marginLeft: 10 }}>失败{newList.filter(item => ['error', 'fail'].includes(item.asyncStatus)).length}</span>
                                <span style={{ color: '#ccc', marginLeft: 10 }}>上传中{newList.filter(item => item.asyncStatus === 'uploading' || item.asyncStatus === '').length}</span>
                            </>,
                            duration: 0,
                            description: <UploadList data={newList} />,
                        });
                    },
                    onTimeout: (newList) => {
                        notification.open({
                            top: 100,
                            key: 'upload-list',
                            duration: 0,
                            message: '部分图片仍在后台处理中，请稍后刷新页面查看最终结果',
                            description: <UploadList data={newList} />,
                        });
                    },
                    onComplete: (newList) => {
                        window.postMessage({ security: true, eventName: 'refreshPicsClassify', flowId }, '*');
                        const failList = newList.filter(item => ['error', 'fail'].includes(item.asyncStatus));
                        notification.open({
                            top: 100,
                            key: 'upload-list',
                            duration: failList.length === 0 ? 3 : 0,
                            description: <UploadList successCount={newList.filter(item => item.asyncStatus === 'success').length} status='finish' data={failList} />,
                        });
                    },
                });
            })
                .catch(err => console.log(err))



        // if (error) return message.error('图片上传失败');
        // return error;
    }

    handleOk = e => {
        const { value } = this.state
        if (value.length === 0) {
            message.info('请选择损失方')
            return

        }
        this.searchBusniessAccounts()

        this.setState({
            visibleLoss: false,
            loadingModalContentTable: true,
        });

        setTimeout(() => {

            const ModalContentTable = document.getElementById("ModalContentTable").contentWindow


            try {
                ModalContentTable.postMessage({ security: true, eventName: 'render-accounts', list: this.state.list, sourceList: this.state.sourceList }, '*')
                this.setState({

                    loadingModalContentTable: false,
                });
            } catch (error) {

            }

        }, 3000);
    };

    handleCancel = e => {
        this.setState({
            visibleLoss: false,
        });
    };

    onChangeCheckbox = (value) => {
        this.setState({
            value,
        });

    }
    //
    searchBusniessAccounts = () => {
        const { currentAgent } = this.props
        // 获取指派对象
        axios({
            method: 'get',
            url: `/api/agents/adjust/${currentAgent.orgAccount && currentAgent.orgAccount._id}`,
            params: {

            }
        }).then(res => {
            if (res.data.errCode == 0) {
                this.setState({
                    list: res.data.result,
                    sourceList: res.data.result

                })
                this.showClaimAdjusterModal()
            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error(err.message || '请求/api/agents/adjust/失败')
        })
    }
    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };
    showClaimAdjusterModal = () => {
        this.setState({
            visibleClaimAdjuster: true,
        });
    };

    handleClaimAdjusterOk = e => {
        const { currentAgent, reportPreview, actions, flowId } = this.props
        const { value, selectedRowKeys } = this.state



        if (this.state.selectedRowKeys.length === 0) {
            message.error('请先选择理算员')
            return

        }
        axios({
            method: 'post',
            url: `/api/adjustReport/batch/create`,
            data: {

                _id: reportPreview.currentPreviewReport._id,
                agentId: selectedRowKeys.join(),
                lossIds: value

            }
        }).then(res => {
            if (res.data.errCode == 0) {
                message.success('推送成功')
                actions.getCurrentReport(flowId)
                this.setState({
                    visibleClaimAdjuster: false,
                    value: [],
                    selectedRowKeys: []

                });
            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error(err.message || '请求/api/adjustReport/batch/create失败')
        })


    };
    handleSendOneself = () => {
        const { currentAgent, reportPreview, actions, flowId } = this.props
        const { value, selectedRowKeys } = this.state
        axios({
            method: 'post',
            url: `/api/adjustReport/batch/create`,
            data: {

                _id: reportPreview.currentPreviewReport._id,
                agentId: currentAgent._id,
                lossIds: value

            }
        }).then(res => {
            if (res.data.errCode == 0) {
                message.success('推送成功')
                actions.getCurrentReport(flowId)
                this.setState({
                    visibleClaimAdjuster: false,
                    value: [],
                    selectedRowKeys: []

                });
            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error(err.message || '请求/api/adjustReport/batch/create失败')
        })
    }

    handleClaimAdjusterCancel = e => {

        this.setState({
            visibleClaimAdjuster: false,
            list: [],
            selectedRowKeys: [],
            flowId: undefined,
            cooperate: [],
            searchCooperate: undefined,
            keyWord: undefined
        });
    };
    handleChangeSearchCooperate = (value) => {
        this.setState({
            searchCooperate: value
        })
    }
    handleSearch = (value) => {
        const { sourceList } = this.state
        if (!value) {
            this.setState({
                list: sourceList
            })
            return
        }
        const filterList = sourceList.filter(item => item.fullName && item.fullName.includes(value))
        this.setState({
            list: filterList
        })
    }


    skip = (loss) => {

        const timeStamp = new Date().getTime();
        this.props.history.push(`/medicalAdjustment?flowId=${loss.stateInfo && loss.stateInfo.flowId}&key=${timeStamp}&activeKey=${2}`);

    }

    // 太保已查勘
    onCpicConfirmSurveied = () => {
        const { actions, currentAgent, flowId } = this.props;
        actions.resetReportStateByAgent({ flowId, state: 'surveied', agentId: currentAgent._id });
    }

    // 接收任务
    acceptReport = async () => {
        const { reportPreview = {}, actions, currentAgent, flowId } = this.props;
        const { currentPreviewReport = {} } = reportPreview;
        await actions.acceptReport(currentPreviewReport, currentAgent._id);
        actions.getLatestReport(flowId);
    }
    // 接收定损任务
    acceptDefLossTask = async () => {
        const { reportPreview = {}, currentAgent, actions, flowId } = this.props;
        const { currentPreviewReport = {} } = reportPreview;
        await actions.acceptDefLossTask(currentPreviewReport, currentAgent._id);
        actions.getLatestReport(flowId);
    }

    //获取工单的理算信息
    getAdjustReportInfo = () => {
        const { reportPreview = {}, actions, currentAgent, flowId } = this.props;

        if (!flowId) {
            return
        }
        axios({
            method: 'GET',
            url: `/api/adjustReport/v2/${flowId}`,
            params: {
                flowId,
                agentId: currentAgent._id

            }
        }).then(res => {
            if (res.data.errCode == 0) {
                this.setState({
                    adjustStatus: 'finish',
                    adjust: res.data.result,
                })

            } else {
                this.setState({
                    adjustStatus: 'create',

                })
                // message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error(err.message)
        })

    }
    //创建医疗理算工单
    handleCreate = () => {
        const { reportPreview = {}, actions, currentAgent, flowId } = this.props;

        if (!flowId) {
            return
        }
        axios({
            method: 'POST',
            url: '/api/adjustReport/v2',
            headers: {
                flowId,
                agentId: currentAgent._id
            },
            data: {
                flowId,
                agentId: currentAgent._id

            }
        }).then(res => {
            if (res.data.errCode == 0) {
                this.setState({
                    adjustStatus: 'finish',
                    adjust: res.data.result,
                })

            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error(err.message)
        })

    }
    uploadAgentPic = () => {
        const { currentAgent, flowId } = this.props;
        if (!flowId) {
            return
        }
        axios({
            method: 'POST',
            url: `/api/adjustReport/v2/${flowId}/uploadPics`,
            headers: {
                flowId,
                agentId: currentAgent._id
            },
            data: {
                flowId,
                agentId: currentAgent._id

            }
        }).then(res => {
            if (res.data.errCode == 0) {
                message.success('操作成功')

            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error(err.message)
        })

    }
    viewAdjustDetails = () => {
        const { currentAgent, flowId } = this.props;
        if (!flowId) {
            return
        }
        // 获取受理号

        axios({
            method: 'GET',
            url: `/api/adjustReport/v2/${flowId}/fetch`,
            headers: {
                flowId,
                agentId: currentAgent._id
            },
            data: {
                flowId,
                agentId: currentAgent._id

            }
        }).then(res => {
            if (res.data.errCode == 0) {

                const adjustFlowId = res.data.result.adjustFlowId


                axios({
                    method: 'POST',
                    url: `/api/adjustReport/auth`,
                    data: {
                        loginName: localStorage.getItem('preSaveName'),
                        password: localStorage.getItem('preSavePwd'),

                    }
                }).then(res => {
                    if (res.data.errCode == 0) {
                        const adjustAccessToken = res.data.result.adjustAccessToken

                        const timeStamp = new Date().getTime();
                        if (adjustFlowId) {
                            const src = `${newMedicalcheckDomain}/medicalcaredetails?flowId=${adjustFlowId}&timeStamp=${timeStamp}&companyId=${currentAgent.tenant && currentAgent.tenant._id}&orgId=${currentAgent.orgAccount && currentAgent.orgAccount._id}&agentId=${currentAgent._id}&accountAccess=${currentAgent.agentRole && currentAgent.agentRole.level}&activeKey=${''}&isCreateAdjust=${currentAgent.isCreateAdjust}&imgBasePath=${currentAgent.tenant && currentAgent.tenant.imgBasePath}&bucketName=${currentAgent.tenant && currentAgent.tenant.imgBasePath}&server=${server}&isFastOcr=${currentAgent.orgAccount && currentAgent.orgAccount.isFastOcr}&isAccurateOcr=${currentAgent.orgAccount && currentAgent.orgAccount.isAccurateOcr}&isCrowdsourceOcr=${currentAgent.orgAccount && currentAgent.orgAccount.isCrowdsourceOcr}&token=${adjustAccessToken}`;

                            window.open(src)
                        }

                    } else {
                        message.error(res.data.errInfo)
                    }
                }).catch(err => {
                    message.error(err.message)
                })

            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error(err.message)
        })

    }
    handleRefresh = () => {
        const { currentAgent, flowId } = this.props;
        if (!flowId) {
            return
        }
        axios({
            method: 'GET',
            url: `/api/adjustReport/v2/${flowId}/fetch`,
            headers: {
                flowId,
                agentId: currentAgent._id
            },
            data: {
                flowId,
                agentId: currentAgent._id

            }
        }).then(res => {
            if (res.data.errCode == 0) {
                message.success('操作成功')
                this.setState({
                    adjustStatus: 'finish',
                    adjust: res.data.result,
                })
                // 重新获取工单详情

                res.data.result.status === 'claimed' && this.props.actions.getCurrentReport(flowId, currentAgent._id)


            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error(err.message)
        })
    }

    downloadFile = (url) => {
        try {
            var elemIF = document.createElement("iframe");
            elemIF.src = url;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
        } catch (e) {

        }
    }

    render() {
        const element = document.getElementById('special-element');
        if (element) {
            element.style.top = '0'
        }
        let _this = this;
        const { reportPreview, actions, currentAgent, flowId } = this.props;
        const { currentPreviewReport } = reportPreview;
        const SUB_STATES = {
            'reject': '拒赔',
            'withdraw': '用户撤案',
            // 'remitted': '结案打款',
        };


        //身份证：IDCard 驾驶证：drivingLicence 行驶证:travelLicence 银行卡：bankCard
        const { ownCarLoss = {}, otherCarLoss = [] } = currentPreviewReport;

        let selectedCar = [ownCarLoss, ...otherCarLoss].find(car => car._id === _this.state.currentCar);

        const { defLossTask = {} } = currentPreviewReport;
        const isDefLossAgent = defLossTask.agentId && (defLossTask.agentId === currentAgent._id);
        const isReportAgent = currentPreviewReport.agentId && ((currentPreviewReport.agentId === currentAgent._id) || (currentPreviewReport.agentId._id === currentAgent._id));
        const canDefLoss = hasDefLossPermission(currentAgent);
        const canCollector = hasCollectorPermission(currentAgent);
        const canClaim = hasClaimPermission(currentAgent);

        const uploadPermission = isShowLocalUploadButton(
            currentPreviewReport,
            currentAgent
        );

        return (
            <div className="fastforentsics-name-space">
                <div style={{ display: 'none' }}>
                    {JSON.stringify(this.state.date)}
                </div>
                <div className={'first-hurry-div first-hurry-height'}>
                    {selectedCar ?
                        <div className="fastforentsics-body">
                            <div className="car-and-card-div">
                                <CarAndCardPicsTab
                                    reportPreview={reportPreview}
                                    currentCar={selectedCar}
                                    actions={actions}
                                    source={1}
                                    flowId={flowId}
                                    uploadPermission={uploadPermission}
                                    currentAgent={currentAgent}
                                    ref={this.CarAndCardPicsTab}
                                />
                            </div>
                        </div> : <div></div>}


                </div>
                <div className="fastforentsics-foot">
                    <div className="user-Data-foot">
                        <div style={{ float: 'right' }} >
                            {
                                uploadPermission ? <Upload

                                    name='file'
                                    action='/api/lossAss/shotPics'
                                    style={{ margin: '0 4px', visibility: 'hidden' }}
                                    showUploadList={false}
                                    multiple
                                    accept='image/png,image/jpeg'
                                    beforeUpload={this.beforeLocalUpload}
                                >
                                    <Button
                                        ref={(uploadButton) => this.uploadButton = uploadButton}
                                        type='primary' style={{ margin: '0 5px', backgroundColor: '#D3AF20', display: 'none' }}>本地上传</Button>
                                </Upload> : null
                            }
                            {
                                uploadPermission ? <Button
                                    onClick={(event) => {
                                        shotPicsCheck({ flowId: flowId }).then(({ result: { checked } }) => {
                                            console.log(checked)
                                            // true 表示能继续上传
                                            if (!checked) {
                                                message.info('有影像正在上传，等待上传完成后重试')
                                                return
                                            }
                                            this.uploadButton.click()
                                        })
                                    }}
                                    type='primary' ghost style={{ margin: '0 5px', borderColor: '#316DEE', color: '#316DEE' }}>本地上传</Button>
                                    : null
                            }
                            {
                                ['untreated'].includes(currentPreviewReport.state)
                                    && !currentPreviewReport.agentId
                                    && canCollector ? <Button type='primary' ghost style={{ margin: '0 5px', borderColor: '#316DEE', color: '#316DEE' }} onClick={this.acceptReport} >报案接收</Button> : null
                            }
                            {
                                canDefLoss
                                    && ['tocheck'].includes(defLossTask.state) ? <Button type='primary' ghost style={{ margin: '0 5px', borderColor: '#58AF5B', color: '#58AF5B' }} onClick={this.acceptDefLossTask} >定损接收</Button> : null
                            }
                            {
                                ['surveied'].includes(currentPreviewReport.state)
                                    && canClaim ? <Button type='primary' ghost style={{ margin: '0 5px', borderColor: '#316DEE', color: '#316DEE' }} onClick={this.acceptReport} >理赔接收</Button> : null
                            }
                            {
                                isReportAgent
                                    && canCollector
                                    && ['holdedOn', 'returned'].includes(currentPreviewReport.state) ? <Button type='primary' ghost style={{ margin: '0 5px' }} onClick={() => this.showReturnedMsg({ returnType: 'collect' })} danger>资料退回</Button> : null
                            }
                            {
                                isReportAgent
                                    && ['claiming', 'claimReturned'].includes(currentPreviewReport.state) ? <Button type='primary' ghost style={{ margin: '0 5px'}} onClick={() => this.showReturnedMsg({ returnType: 'claim' })} danger>理赔退回</Button> : null
                            }
                            {
                                isDefLossAgent
                                    && canDefLoss
                                    && ['checking'].includes(defLossTask.state)
                                    && !['checked', 'finished'].includes(currentPreviewReport.state) ? <Button type='primary' ghost style={{ margin: '0 5px' }} onClick={() => this.showReturnedMsg({ returnType: 'defloss' })} danger>定损退回</Button> : null
                            }
                            {
                                isReportAgent
                                    && canCollector
                                    && ['holdedOn', 'returned'].includes(currentPreviewReport.state) ? <Popconfirm
                                        title="确定查勘已完成?"
                                        onConfirm={this.onCpicConfirmSurveied}

                                        okText="确定"
                                        cancelText="取消"
                                    >
                                    <Button type='primary' ghost style={{ margin: '0 5px', borderColor: '#316DEE', color: '#316DEE' }} >已查勘</Button>
                                </Popconfirm> : null
                            }

                            {
                                ['untreated'].includes(currentPreviewReport.state) ? <Popover
                                    style={{ margin: '0 5px' }}
                                    title='请选择结案类型'
                                    visible={this.state.isShowSubStateConfirm}
                                    trigger="click"
                                    content={
                                        <React.Fragment>
                                            <Radio.Group onChange={(e) => this.setState({ subState: e.target.value })} value={this.state.subState} >
                                                <Space direction="vertical">
                                                    {
                                                        <Radio value={'withdraw'} key={'withdraw'}>
                                                            {SUB_STATES['withdraw']}
                                                        </Radio>
                                                    }
                                                </Space>
                                            </Radio.Group>
                                            <div style={{ marginTop: 15 }}>
                                                <Button style={{ marginRight: '10px' }} size='small' onClick={() => this.setState({ isShowSubStateConfirm: false })}>取消</Button>
                                                <Button type='primary' size='small' onClick={this.onFinishClick}>确定</Button>
                                            </div>
                                        </React.Fragment>
                                    }
                                >
                                    <Button type='primary' ghost style={{ margin: '0 5px' }} onClick={() => this.setState({ isShowSubStateConfirm: true })} danger>已结案</Button>
                                </Popover> : null
                            }
                            {
                                isReportAgent
                                    && ['holdedOn', 'returned', 'claiming', 'claimReturned'].includes(currentPreviewReport.state) ? <Popover
                                        style={{ margin: '0 5px' }}
                                        title='请选择结案类型'
                                        visible={this.state.isShowSubStateConfirm}
                                        trigger="click"
                                        content={
                                            <React.Fragment>
                                                <Radio.Group onChange={(e) => this.setState({ subState: e.target.value })} value={this.state.subState} >
                                                    <Space direction="vertical">
                                                        {
                                                            Object.keys(SUB_STATES)
                                                                .filter(k => {
                                                                    return ['holdedOn', 'returned'].includes(currentPreviewReport.state)
                                                                        && !['withdraw'].includes(k) ? false : true;
                                                                })
                                                                .map(key => (
                                                                    <Radio value={key} key={key}>
                                                                        {SUB_STATES[key]}
                                                                    </Radio>
                                                                ))
                                                        }
                                                    </Space>
                                                </Radio.Group>
                                                <div style={{ marginTop: 15 }}>
                                                    <Button style={{ marginRight: '10px' }} size='small' onClick={() => this.setState({ isShowSubStateConfirm: false })}>取消</Button>
                                                    <Button type='primary' size='small' onClick={this.onFinishClick}>确定</Button>
                                                </div>
                                            </React.Fragment>
                                        }
                                    >
                                    <Button type='primary' ghost style={{ margin: '0 5px' }} onClick={() => this.setState({ isShowSubStateConfirm: true })} danger>已结案</Button>
                                </Popover> : null
                            }

                            <RemarkBtn currentAgent={currentAgent} flowId={flowId} />
                            {/* 新增按钮医疗理算 */}
                            {
                                currentAgent.orgAccount.isAdjust &&
                                    ['claiming', 'claimReturned'].includes(currentPreviewReport.state) ? <Popover content={
                                        this.state.adjustStatus === 'create' ?
                                            <div>
                                                <p>尚未创建医核工单</p>
                                                <Button
                                                    type='primary'
                                                    style={{ margin: '0px 0px 0px 60px' }}
                                                    onClick={this.handleCreate}

                                                >
                                                    点击创建
                                                </Button>
                                            </div>
                                            :
                                            <div>
                                                <p>审核状态:{statusMap[this.state.adjust.status]}
                                                    {
                                                        this.state.adjust.status === 'claiming' && <i className="iconfont icon-sync" onClick={this.handleRefresh} style={{ marginLeft: 20 }} />
                                                    }
                                                </p>
                                                <p>处理人:{this.state.adjust.username} {this.state.adjust.cellphone}</p>
                                                {
                                                    this.state.adjust.status === 'claiming' &&
                                                    isSurveyAgentRole(currentAgent) &&
                                                    <Button
                                                        style={{ margin: '0px 0px 0px 60px' }}
                                                        onClick={this.uploadAgentPic}

                                                    >
                                                        更新照片
                                                    </Button>
                                                }
                                                {/* 登录坐席.agentRole.level === '2' //机构管理员 登录坐席.agentRole.level === '3' //公司管理员 */}
                                                {
                                                    (isAdjustAgentRole(currentAgent) ||
                                                        (
                                                            currentAgent.agentRole.level === '2'
                                                            ||
                                                            currentAgent.agentRole.level === '3'
                                                        )

                                                    ) &&
                                                    <Button
                                                        type='primary'
                                                        style={{ margin: '0px 0px 0px 20px' }}
                                                        onClick={this.viewAdjustDetails}

                                                    >
                                                        进入医核
                                                    </Button>
                                                }

                                            </div>
                                    }
                                        title=""
                                        trigger="click"
                                    >
                                    <Button type='primary'
                                        style={{ margin: '0 4px', backgroundColor: '#D3AF20' }}
                                    >
                                        医疗理算
                                    </Button>
                                </Popover> : null

                            }

                        </div>
                    </div>
                </div>


                {/* 查看loss弹窗 */}
                <Modal
                    destroyOnClose
                    title="确定人伤医疗票据等信息取证完成，且推送医疗理算？"
                    visible={this.state.visibleLoss}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <Spin tip="Loading..." spinning={this.state.loadingModalContent}>
                        <iframe id='lossIframe' style={{ border: 'none' }} src={newMedicalcheckDomain + '/ModalContent'} width='100%' height='50%' frameborder="0"></iframe>
                    </Spin>

                </Modal>

                <Modal
                    title="请选择理算员"
                    visible={this.state.visibleClaimAdjuster}
                    onOk={this.handleClaimAdjusterOk}
                    onCancel={this.handleClaimAdjusterCancel}
                    destroyOnClose
                    okText='确定推送'
                    footer={[
                        currentAgent.agentRole.isAdjust &&
                        <Button style={{ float: 'left' }} key="oneself" onClick={this.handleSendOneself}>
                            推送给自己
                        </Button>,
                        <Button key="取消" onClick={this.handleClaimAdjusterCancel}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.handleClaimAdjusterOk}>
                            确定推送
                        </Button>,
                    ]}
                >
                    <Spin tip="Loading..." spinning={this.state.loadingModalContentTable}>
                        <iframe id='ModalContentTable' style={{ border: 'none' }} src={newMedicalcheckDomain + '/ModalContentTable'} width='100%' height='50%' frameborder="0"></iframe>
                    </Spin>

                </Modal>
                {/*  */}


            </div>
        );
    }
}


let mapStateToProps = (state) => {
    return {
        customers: state.app.customers.current,
        currentAgent: state.app.currentAgent.userInfo,
        ocr: state.lossAss.ocr
    }
}

let mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Object.assign({},
            kandyActions,
            screenShotActions,
            reportPreviewActions,
            report
        ), dispatch)
    }
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FastForensics)




